import React, { useState, useEffect, useCallback } from 'react';

/* ═══════════════════════════════════════════
   DRACULADEV KIDS — Interactive Course Slideshow
   Magical presentation built directly in React
   ═══════════════════════════════════════════ */

const SLIDES = [
  {
    id: 'intro',
    bg: 'radial-gradient(ellipse at 50% 30%, rgba(189,147,249,0.15) 0%, transparent 60%), linear-gradient(180deg, #0f0a1e 0%, #1a1035 50%, #0d0820 100%)',
    content: (active) => (
      <div style={{ textAlign: 'center', maxWidth: 700, margin: '0 auto' }}>
        <div style={{
          fontSize: 80, marginBottom: 16,
          animation: active ? 'slideFloat 3s ease-in-out infinite' : 'none',
          filter: 'drop-shadow(0 0 30px rgba(189,147,249,0.5))',
        }}>🏰</div>
        <h1 style={{
          fontSize: 'clamp(32px, 6vw, 56px)', fontWeight: 900, lineHeight: 1.1, marginBottom: 16,
          fontFamily: "'Nunito', sans-serif",
        }}>
          <span style={{ color: '#f8f8f2' }}>Învață să </span>
          <span style={{
            background: 'linear-gradient(135deg, #ff79c6, #bd93f9, #50fa7b)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>programezi</span>
          <br />
          <span style={{ color: '#ff79c6' }}>ca un vrăjitor!</span>
        </h1>
        <p style={{ color: '#8b90a8', fontSize: 18, lineHeight: 1.6, fontFamily: "'Nunito', sans-serif" }}>
          Cursuri de programare pentru copii <span style={{ color: '#f1fa8c', fontWeight: 700 }}>7-11 ani</span>
          <br />Jocuri, animații și aventuri magice în lumea codului!
        </p>
      </div>
    ),
  },
  {
    id: 'courses',
    bg: 'radial-gradient(ellipse at 30% 70%, rgba(80,250,123,0.1) 0%, transparent 50%), linear-gradient(180deg, #0d0820 0%, #0f1a2e 50%, #0a0f1e 100%)',
    content: (active) => {
      const courses = [
        { emoji: '🐍', name: 'Python Magic', age: '8-11 ani', desc: 'Creează jocuri și animații!', color: '#50fa7b', lessons: 12 },
        { emoji: '🌐', name: 'HTML Castelul', age: '7-10 ani', desc: 'Construiește site-uri magice!', color: '#ff79c6', lessons: 10 },
        { emoji: '🎨', name: 'CSS Poțiuni', age: '8-11 ani', desc: 'Colorează web-ul cu efecte!', color: '#bd93f9', lessons: 10 },
        { emoji: '🎮', name: 'Game Dev', age: '9-11 ani', desc: 'Creează jocuri reale!', color: '#ffb86c', lessons: 14 },
      ];
      return (
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 32, fontWeight: 900, marginBottom: 8, fontFamily: "'Nunito', sans-serif" }}>
            <span style={{ color: '#f1fa8c' }}>✨</span> 4 Cursuri Magice <span style={{ color: '#f1fa8c' }}>✨</span>
          </h2>
          <p style={{ textAlign: 'center', color: '#6272a4', fontSize: 14, marginBottom: 36 }}>Alege super-puterea potrivită</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
            {courses.map((c, i) => (
              <div key={i} style={{
                background: `${c.color}08`, border: `2px solid ${c.color}25`,
                borderRadius: 16, padding: '24px 20px', textAlign: 'center',
                opacity: active ? 1 : 0,
                transform: active ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
                transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${0.15 * i}s`,
              }}>
                <div style={{ fontSize: 44, marginBottom: 8 }}>{c.emoji}</div>
                <div style={{ color: c.color, fontSize: 18, fontWeight: 900, marginBottom: 2, fontFamily: "'Nunito', sans-serif" }}>{c.name}</div>
                <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 20, padding: '2px 12px', fontSize: 11, color: '#f1fa8c', fontWeight: 700, display: 'inline-block', marginBottom: 8 }}>{c.age}</div>
                <div style={{ color: '#8b90a8', fontSize: 13, marginBottom: 6 }}>{c.desc}</div>
                <div style={{ color: '#44475a', fontSize: 11 }}>📚 {c.lessons} lecții</div>
              </div>
            ))}
          </div>
        </div>
      );
    },
  },
  {
    id: 'formats',
    bg: 'radial-gradient(ellipse at 70% 30%, rgba(255,121,198,0.12) 0%, transparent 50%), linear-gradient(180deg, #0a0f1e 0%, #15102a 50%, #0d0820 100%)',
    content: (active) => {
      const formats = [
        { icon: '🧑‍🏫', title: '1-to-1 Private', sub: 'Atenție 100%', price: '80', color: '#ff79c6', desc: 'Lecții personalizate, ritm propriu. Ideal pentru începători.' },
        { icon: '👥', title: 'Clase Mici', sub: '3-5 copii', price: '50', color: '#bd93f9', desc: 'Grupuri mici, proiecte colaborative. Învață cu prietenii!' },
        { icon: '🏫', title: 'Clase Mari', sub: '8-12 copii', price: '30', color: '#50fa7b', desc: 'Workshop-uri, competiții. Energie de echipă!' },
      ];
      return (
        <div style={{ maxWidth: 750, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 32, fontWeight: 900, marginBottom: 8, fontFamily: "'Nunito', sans-serif" }}>
            🎯 Alege Formatul Potrivit
          </h2>
          <p style={{ textAlign: 'center', color: '#6272a4', fontSize: 14, marginBottom: 36 }}>Fiecare copil învață diferit</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
            {formats.map((f, i) => (
              <div key={i} style={{
                background: `${f.color}06`, border: `2px solid ${f.color}20`,
                borderRadius: 16, padding: '28px 18px', textAlign: 'center',
                opacity: active ? 1 : 0,
                transform: active ? 'translateY(0)' : 'translateY(30px)',
                transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${0.2 * i}s`,
              }}>
                <div style={{ fontSize: 40, marginBottom: 10 }}>{f.icon}</div>
                <div style={{ color: f.color, fontSize: 17, fontWeight: 900, marginBottom: 2, fontFamily: "'Nunito', sans-serif" }}>{f.title}</div>
                <div style={{ color: '#8b90a8', fontSize: 12, fontWeight: 600, marginBottom: 12 }}>{f.sub}</div>
                <div style={{ color: '#8b90a8', fontSize: 12, lineHeight: 1.5, marginBottom: 14 }}>{f.desc}</div>
                <div style={{ fontSize: 28, fontWeight: 900, color: f.color }}>{f.price} <span style={{ fontSize: 13, color: '#6272a4' }}>RON/lecție</span></div>
              </div>
            ))}
          </div>
        </div>
      );
    },
  },
  {
    id: 'how',
    bg: 'radial-gradient(ellipse at 50% 50%, rgba(139,233,253,0.1) 0%, transparent 50%), linear-gradient(180deg, #0d0820 0%, #0f1a2e 50%, #0a0f1e 100%)',
    content: (active) => {
      const steps = [
        { num: '1', icon: '📝', title: 'Alegi cursul', desc: 'Selectezi cursul și formatul care se potrivește copilului tău.', color: '#50fa7b' },
        { num: '2', icon: '🎁', title: 'Lecție demo GRATUITĂ', desc: 'Prima lecție e pe noi! Testezi fără nicio obligație.', color: '#ff79c6' },
        { num: '3', icon: '🚀', title: 'Începe aventura!', desc: 'Copilul intră în lumea codului cu proiecte reale și fun.', color: '#bd93f9' },
      ];
      return (
        <div style={{ maxWidth: 650, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 32, fontWeight: 900, marginBottom: 36, fontFamily: "'Nunito', sans-serif" }}>
            ⚡ Cum Funcționează
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            {steps.map((s, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 20,
                opacity: active ? 1 : 0,
                transform: active ? 'translateX(0)' : 'translateX(-40px)',
                transition: `all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${0.25 * i}s`,
              }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: `${s.color}15`, border: `2px solid ${s.color}40`,
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  fontSize: 32, flexShrink: 0,
                }}>{s.icon}</div>
                <div>
                  <div style={{ color: s.color, fontSize: 11, fontWeight: 700, letterSpacing: 1.5, marginBottom: 2 }}>PASUL {s.num}</div>
                  <div style={{ color: '#f8f8f2', fontSize: 20, fontWeight: 800, marginBottom: 4, fontFamily: "'Nunito', sans-serif" }}>{s.title}</div>
                  <div style={{ color: '#8b90a8', fontSize: 14, lineHeight: 1.5 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    },
  },
  {
    id: 'benefits',
    bg: 'radial-gradient(ellipse at 40% 60%, rgba(241,250,140,0.08) 0%, transparent 50%), linear-gradient(180deg, #0a0f1e 0%, #12102a 50%, #0d0820 100%)',
    content: (active) => {
      const benefits = [
        { icon: '👨‍🏫', text: 'Profesori pasionați cu experiență' },
        { icon: '🎮', text: 'Lecții interactive, bazate pe joc' },
        { icon: '🏆', text: 'Fiecare copil lucrează pe propriul proiect' },
        { icon: '📜', text: 'Certificat de absolvire DraculaDev' },
        { icon: '🌐', text: 'Online sau la sediu în București' },
        { icon: '🎁', text: 'Prima lecție e GRATUITĂ!' },
      ];
      return (
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 32, fontWeight: 900, marginBottom: 36, fontFamily: "'Nunito', sans-serif" }}>
            💎 De Ce DraculaDev Kids?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            {benefits.map((b, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: 14,
                background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: 12, padding: '14px 16px',
                opacity: active ? 1 : 0,
                transform: active ? 'translateY(0)' : 'translateY(15px)',
                transition: `all 0.5s ease ${0.1 * i}s`,
              }}>
                <span style={{ fontSize: 28, flexShrink: 0 }}>{b.icon}</span>
                <span style={{ color: '#c0c4d8', fontSize: 14, fontWeight: 600, fontFamily: "'Nunito', sans-serif" }}>{b.text}</span>
              </div>
            ))}
          </div>
        </div>
      );
    },
  },
  {
    id: 'cta',
    bg: 'radial-gradient(ellipse at 50% 40%, rgba(255,121,198,0.15) 0%, transparent 50%), radial-gradient(ellipse at 50% 80%, rgba(80,250,123,0.1) 0%, transparent 50%), linear-gradient(180deg, #0d0820 0%, #15102a 50%, #0f0a1e 100%)',
    content: (active) => (
      <div style={{ textAlign: 'center', maxWidth: 550, margin: '0 auto' }}>
        <div style={{
          fontSize: 72, marginBottom: 20,
          animation: active ? 'slideFloat 2.5s ease-in-out infinite' : 'none',
        }}>🧛</div>
        <h2 style={{
          fontSize: 36, fontWeight: 900, marginBottom: 12, fontFamily: "'Nunito', sans-serif",
          background: 'linear-gradient(135deg, #ff79c6, #bd93f9, #50fa7b)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>
          Aventura codului începe aici!
        </h2>
        <p style={{ color: '#8b90a8', fontSize: 16, lineHeight: 1.6, marginBottom: 12 }}>
          Prima lecție este <span style={{ color: '#50fa7b', fontWeight: 800 }}>100% GRATUITĂ</span>
        </p>
        <p style={{ color: '#6272a4', fontSize: 14, marginBottom: 32 }}>
          Fără obligații. Fără costuri ascunse. Doar magie pură. 🧄
        </p>
        <div style={{
          display: 'inline-flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center',
          opacity: active ? 1 : 0,
          transform: active ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.6s ease 0.3s',
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #50fa7b, #8be9fd)',
            borderRadius: 50, padding: '14px 36px',
            color: '#0d0e12', fontWeight: 800, fontSize: 16,
            fontFamily: "'Nunito', sans-serif",
            boxShadow: '0 4px 25px rgba(80,250,123,0.3)',
          }}>
            🚀 Începe aventura pe draculadev.com
          </div>
        </div>
        <div style={{ marginTop: 24, color: '#44475a', fontSize: 12 }}>
          De la <span style={{ color: '#f1fa8c', fontWeight: 700 }}>30 RON</span>/lecție • 7-11 ani • Online sau București
        </div>
      </div>
    ),
  },
];

/* ═══════════════════════════════════════════
   SLIDESHOW COMPONENT
   ═══════════════════════════════════════════ */
const CourseSlideshow = ({ onClose }) => {
  const [current, setCurrent] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(false);

  const goNext = useCallback(() => {
    setCurrent(c => (c + 1) % SLIDES.length);
  }, []);

  const goPrev = useCallback(() => {
    setCurrent(c => c === 0 ? SLIDES.length - 1 : c - 1);
  }, []);

  // Keyboard navigation
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') { e.preventDefault(); goNext(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goPrev(); }
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [goNext, goPrev, onClose]);

  // Auto-play
  useEffect(() => {
    if (!isAutoPlay) return;
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [isAutoPlay, goNext]);

  const slide = SLIDES[current];

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 500,
      background: '#000',
      display: 'flex', flexDirection: 'column',
    }}>
      <style>{`
        @keyframes slideFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes starTwinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>

      {/* Top bar */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '10px 20px',
        background: 'rgba(13,8,32,0.9)',
        borderBottom: '1px solid rgba(189,147,249,0.1)',
        zIndex: 10,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 20 }}>🧛</span>
          <span style={{
            fontSize: 15, fontWeight: 800, color: '#f8f8f2',
            fontFamily: "'Nunito', sans-serif",
          }}>DraculaDev Kids</span>
          <span style={{
            background: '#bd93f920', border: '1px solid #bd93f930',
            borderRadius: 6, padding: '2px 10px',
            fontSize: 10, color: '#bd93f9', fontWeight: 700,
          }}>{current + 1} / {SLIDES.length}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Auto-play toggle */}
          <button onClick={() => setIsAutoPlay(!isAutoPlay)} style={{
            background: isAutoPlay ? '#50fa7b20' : 'transparent',
            border: `1px solid ${isAutoPlay ? '#50fa7b' : '#44475a'}`,
            borderRadius: 6, padding: '4px 12px',
            color: isAutoPlay ? '#50fa7b' : '#6272a4',
            fontSize: 11, fontWeight: 600, cursor: 'pointer',
            fontFamily: "'Nunito', sans-serif",
          }}>
            {isAutoPlay ? '⏸ Pauză' : '▶ Auto'}
          </button>

          {/* Close */}
          <button onClick={onClose} style={{
            background: '#ff555515', border: '1px solid #ff555530',
            borderRadius: 8, padding: '5px 14px',
            color: '#ff5555', fontSize: 12, fontWeight: 700, cursor: 'pointer',
            fontFamily: "'Nunito', sans-serif",
          }}>✕ Închide</button>
        </div>
      </div>

      {/* Slide content */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '40px 60px',
        background: slide.bg,
        position: 'relative', overflow: 'hidden',
        transition: 'background 0.8s ease',
      }}>
        {/* Decorative stars */}
        {[...Array(15)].map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            left: `${5 + Math.random() * 90}%`,
            top: `${5 + Math.random() * 90}%`,
            width: 2 + Math.random() * 2, height: 2 + Math.random() * 2,
            borderRadius: '50%', background: '#f8f8f2',
            opacity: 0.3,
            animation: `starTwinkle ${2 + Math.random() * 3}s ease-in-out ${-Math.random() * 3}s infinite`,
            pointerEvents: 'none',
          }} />
        ))}

        {/* Left arrow */}
        <button onClick={goPrev} style={{
          position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '50%', width: 44, height: 44,
          color: '#f8f8f2', fontSize: 18, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all 0.2s', zIndex: 5,
        }}
        onMouseEnter={e => { e.target.style.background = 'rgba(189,147,249,0.2)'; e.target.style.borderColor = '#bd93f9'; }}
        onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.05)'; e.target.style.borderColor = 'rgba(255,255,255,0.1)'; }}>
          ←
        </button>

        {/* Slide */}
        <div key={current} style={{
          width: '100%', maxWidth: 900,
          animation: 'none',
        }}>
          {slide.content(true)}
        </div>

        {/* Right arrow */}
        <button onClick={goNext} style={{
          position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '50%', width: 44, height: 44,
          color: '#f8f8f2', fontSize: 18, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'all 0.2s', zIndex: 5,
        }}
        onMouseEnter={e => { e.target.style.background = 'rgba(80,250,123,0.2)'; e.target.style.borderColor = '#50fa7b'; }}
        onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.05)'; e.target.style.borderColor = 'rgba(255,255,255,0.1)'; }}>
          →
        </button>
      </div>

      {/* Bottom dots */}
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8,
        padding: '14px 20px',
        background: 'rgba(13,8,32,0.9)',
        borderTop: '1px solid rgba(189,147,249,0.1)',
      }}>
        {SLIDES.map((s, i) => (
          <button key={i} onClick={() => setCurrent(i)} style={{
            width: current === i ? 28 : 8, height: 8,
            borderRadius: 4, border: 'none', cursor: 'pointer',
            background: current === i
              ? 'linear-gradient(135deg, #ff79c6, #bd93f9)'
              : 'rgba(255,255,255,0.15)',
            transition: 'all 0.3s ease',
          }} />
        ))}
        <span style={{ marginLeft: 16, color: '#44475a', fontSize: 10, fontFamily: "'Nunito', sans-serif" }}>
          ← → sau spațiu pentru navigare
        </span>
      </div>
    </div>
  );
};

export default CourseSlideshow;